
import { default as Moment } from 'moment';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from "react-router-dom";
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import view_apartment_type_ar from "../../functions/view_apartment_type";
import '../../Helper/links.js';
import { _endPoints, baseUrl, getapartments_dates_coming_resort } from "../../Helper/links.js";
import API from "../../Helper/server/API.js";
import img_apartment from '../../public/images/apartment.png';
let today = new Date();
export let booking_apartments_dates = {};
function BookingApartmentStep({ onDataChange, bookingApartmentData }) {
    const toast = useRef(null);
    const items = Array.from({ length: 5 }, (v, i) => i);
    const [loading_render, set_loading_render] = useState(true);
    // addLocale('en', {
    //   firstDayOfWeek: 1,
    //   dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    //   dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    //   dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    //   monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']    ,
    //   monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    //   today: 'Today',
    //   clear: 'Clear'
    // });
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const Navigate = useNavigate();
    //_______________________________________________________
    const [apartments, setApartments] = useState([]);
    const [dates, setDates] = useState([]);
    //_______________________________________________________
    //                      Dates Apartments
    //_______________________________________________________
    function dates_close(dates_reservationes) {

        var dates_disabled = [];
        // eslint-disable-next-line array-callback-return
        dates_reservationes.map((date) => {
            var date_in = new Date(date.date_check_in);
            var date_out = new Date(date.date_check_out);
            while (Moment(date_in).format("yyyy-MM-DD") < Moment(date_out).format("yyyy-MM-DD")
            ) {
                dates_disabled.push(new Date(Moment(date_in).format("yyyy-MM-DD")));
                date_in.setDate(date_in.getDate() + 1);
            }
        })
        return dates_disabled;
    }
    function dateTemplate(date, dates_reservationes) {
        var IsAvailable = true;
        for (var i = 0; i < dates_reservationes.length; i++) {
            if (
                Moment(date).format("yyyy-MM-DD") >= Moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
                &&
                (
                    Moment(date).format("yyyy-MM-DD") < Moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
                    ||
                    Moment(date).format("yyyy-MM-DD") == Moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
                )
            ) {
                IsAvailable = false;
                break;
            }
        }
        if (!IsAvailable) {
            return (
                <span className="strikethrough-red" >{date.day}</span>
            );
        }
        else {
            return (
                <span style={{ color: "black", fontSize: "16px" }}>{date.day}</span>
            );
        }
    }
    const handelDates = (e, id_apartment) => {
        setDates(e.target.value);
        booking_apartments_dates[id_apartment] = e.target.value;
        onDataChange({
            id_apartment: id_apartment,
            dates: e.target.value
        })

    }
    const clear_days = async (e, id_apartment) => {
        setDates([])
        booking_apartments_dates[id_apartment] = [];
        onDataChange({
            id_apartment: id_apartment,
            dates: []
        })
    }

    //_______________________________________________________________________________________
    //                      Get Apartments
    const GetApartments = async () => {
        const response = await API.get(getapartments_dates_coming_resort)
        if (response?.success === 1) {
            if (Array.isArray(response.data))
                setApartments(response.data);
            // eslint-disable-next-line array-callback-return
            apartments.map((apartment) => {
                booking_apartments_dates[apartment.ID_apartment] = [];
            })
            bookingApartmentData.map((apartment) => {
                return booking_apartments_dates[apartment.id_apartment] = apartment.dates;
            })
            set_loading_render(false)
        }
        else if (response?.success === 0 || response?.errors == 1) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
    }
    useEffect(() => {
        booking_apartments_dates = []
        GetApartments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(50);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    return (
        <div >
            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

            <div dir="rtl" >``
                {loading_render ? (
                    <div className="border-round border-1 surface-border surface-card">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card" style={{ width: "100%" }}>
                                    <Skeleton width="100%" height="350px"></Skeleton>
                                    <DataTable value={items} className="p-datatable-striped">
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                    </DataTable>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card" style={{ width: "100%" }}>
                                    <Skeleton width="100%" height="350px"></Skeleton>
                                    <DataTable value={items} className="p-datatable-striped">
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                    </DataTable>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card" style={{ width: "100%" }}>
                                    <Skeleton width="100%" height="350px"></Skeleton>
                                    <DataTable value={items} className="p-datatable-striped">
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                        <Column style={{ width: '25%' }} body={<Skeleton />}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>

                        <div className="row" >

                            {apartments?.slice(first, first + rows)
                                .map((index, key) => {
                                    return (
                                        <div className="col-md-4" style={{ paddingBottom: "20px" }} key={`div-${first + key}`}>
                                            <div style={{ width: "100%" }} key={`card-${first + key}`}>
                                                {index?.images?.length > 0 ? (
                                                    <>
                                                        {index.images.map((img, k) => (
                                                            <a
                                                                key={img.ID_apartments_file || `img-${k}`}
                                                                data-fancybox={`gallery-${index.ID_apartment}`}
                                                                href={`${_endPoints.apartments.images}${img.path_file}`}
                                                                style={{ display: k === 0 ? 'inline' : 'none' }}
                                                            >
                                                                {k === 0 && (
                                                                    <LazyLoadImage
                                                                        // Alt text should describe the image or its context
                                                                        alt={`Apartment ${index.number || ''} - Image ${k + 1}`}
                                                                        effect="blur"
                                                                        wrapperProps={{
                                                                            style: { transitionDelay: "0.5s" },
                                                                        }}
                                                                        style={{ width: "100%", height: "350px", objectFit: "cover", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", cursor: "pointer" }}
                                                                        src={`${_endPoints.apartments.images}${img.path_file}`}
                                                                        height="350px"
                                                                        onError={e => {
                                                                            e.target.src = img_apartment;
                                                                            e.target.onerror = null; // Prevents infinite loops if fallback fails
                                                                        }}
                                                                    />
                                                                )}
                                                            </a>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <a data-fancybox={`gallery-${index.ID_apartment}`} href={_endPoints.apartments.images + "apartment.png"}>
                                                        <LazyLoadImage
                                                            alt="apartment"
                                                            effect="blur"
                                                            wrapperProps={{
                                                                style: { transitionDelay: "0.5s" },
                                                            }}
                                                            style={{ width: "100%", height: "350px", objectFit: "cover", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", cursor: "pointer" }}
                                                            src={`${_endPoints.apartments.images}apartment.png`}
                                                            height="350px"
                                                            onError={e => {
                                                                e.target.src = img_apartment;
                                                                e.target.onerror = null; // Prevents infinite loops if fallback fails
                                                            }}
                                                        />
                                                    </a>
                                                )}
                                                {/* <Slide autoplay={false}>
                                                    {index?.images?.length > 0 ? (
                                                        index.images.map((image, k) => (
                                                            <a
                                                                // Use a unique ID for the gallery group
                                                                data-fancybox={`gallery-${index.ID_apartment}`}
                                                                href={`${_endPoints.apartments.images}${image.path_file}`}
                                                                // Key belongs on the outermost element in the map
                                                                key={image.ID_apartments_file || `img-${k}`}
                                                            >
                                                                <LazyLoadImage
                                                                    // Alt text should describe the image or its context
                                                                    alt={`Apartment ${index.number || ''} - Image ${k + 1}`}
                                                                    effect="blur"
                                                                    wrapperProps={{
                                                                        style: { transitionDelay: "0.5s" },
                                                                    }}
                                                                    style={{ width: "100%", height: "350px", objectFit: "cover" }}
                                                                    src={`${_endPoints.apartments.images}${image.path_file}`}
                                                                    height="400px"
                                                                    onError={e => {
                                                                        e.target.src = img_apartment;
                                                                        e.target.onerror = null; // Prevents infinite loops if fallback fails
                                                                    }}
                                                                />
                                                            </a>
                                                        ))
                                                    ) :
                                                        (
                                                            <LazyLoadImage
                                                                alt={_endPoints.apartments.images + "apartment.png"}
                                                                effect="blur"
                                                                wrapperProps={{
                                                                    style: { transitionDelay: "1s" },
                                                                }}
                                                                style={{ width: "100%", height: "350px", objectFit: "cover" }}
                                                                key={`apt_`}
                                                                src={_endPoints.apartments.images + "apartment.png"}
                                                                visibleByDefault={false}
                                                                height="400px"
                                                            />
                                                        )}
                                                </Slide> */}
                                                <table className="table table-bordered" style={{ marginBottom: "0px", marginTop: "0px" }}>
                                                    <tbody>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>
                                                                <h6>{view_apartment_type_ar(index) + '  ' + index.number}</h6>
                                                            </th>
                                                            <th style={{ textAlign: "center" }}>
                                                                <h6>{index.number_people} أشخاص</h6>
                                                            </th>
                                                            <th style={{ textAlign: "center" }}>
                                                                {index.discount > 0 ? (
                                                                    <strong style={{ textDecoration: 'line-through', color: "red", fontSize: "13px", display: "inline" }}>
                                                                        {index.price + ' د.ل '}
                                                                    </strong>
                                                                ) : null}
                                                                <h6 style={{ display: "inline" }} className="pr-1">{index.price - index.discount + ' د.ل '}</h6>
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                {index?.images?.length > 0 ? (
                                                    index.images.map((image, k) => (
                                                        <div className="column" style={{ display: "none" }} key={`div-column-${k}`}>
                                                            <a data-fancybox={index.number} href={_endPoints.apartments.images + image}>
                                                                <img className="img-circle" alt="logo" src={_endPoints.apartments.images + image} width="50" height="50" />
                                                            </a>
                                                        </div>
                                                    ))
                                                ) : null}
                                                <div dir="rtl" key={`div-calendar-${first + key}`} style={{ minWidth: "100%" }}>
                                                    <Calendar
                                                        inputId={index.ID_apartment}
                                                        nextIcon={<i className="fa fa-angle-left" style={{ fontSize: "2rem" }}></i>}
                                                        prevIcon={<i className="fa fa-angle-right" style={{ fontSize: "2rem" }}></i>}
                                                        minDate={today}
                                                        maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                                        value={booking_apartments_dates[index.ID_apartment]}
                                                        onChange={e => handelDates(e, index.ID_apartment)}
                                                        dateTemplate={e => dateTemplate(e, index.dates_reservationes)}
                                                        disabledDates={dates_close(index.dates_reservationes)}
                                                        selectionMode="multiple"
                                                        readOnlyInput
                                                        locale="ar"
                                                        style={{ minWidth: "100%" }}
                                                        inline
                                                        dateFormat="yyyy-MM-DD"
                                                        id={"calendar_" + index.id_apartment}
                                                        footerTemplate={() => (
                                                            <table className="table table-bordered" style={{ margin: "0px", padding: "0px" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: "40%" }}>
                                                                            <h6>
                                                                                {booking_apartments_dates[index.ID_apartment] ? (
                                                                                    <>
                                                                                        عدد الأيـام {booking_apartments_dates[index.ID_apartment]?.length}
                                                                                    </>
                                                                                ) : (
                                                                                    <>عدد الأيـام -</>
                                                                                )}
                                                                            </h6>
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: "40%" }}>
                                                                            <h6>
                                                                                {booking_apartments_dates[index.ID_apartment] ? (
                                                                                    <>
                                                                                        السعــر {(index.price - index.discount) * booking_apartments_dates[index.ID_apartment]?.length} د،ل
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        السعــر  {index.price * 0}  د،ل
                                                                                    </>
                                                                                )}
                                                                            </h6>
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", fontSize: "15px" }}>
                                                                            <Button
                                                                                text
                                                                                severity="secondary"
                                                                                icon="fa fa-close"
                                                                                className="pl-4 pr-4"
                                                                                style={{ fontFamily: "Cairo", width: "100%", height: "100%" }}
                                                                                onClick={e => clear_days(e, index.ID_apartment)}
                                                                            />
                                                                        </th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                        </div>
                        <hr></hr>
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={apartments?.length}
                            rowsPerPageOptions={[50, 70, 80, 90, 100]}
                            onPageChange={onPageChange}
                            style={{ fontSize: "16px" }}
                            nextPageLinkIcon="pi pi-chevron-left"
                            lastPageLinkIcon="pi pi-angle-double-left"
                            prevPageLinkIcon="pi pi-chevron-right"
                            firstPageLinkIcon="pi pi-angle-double-right"
                        />

                    </>
                )}
            </div>
        </div>
    )
}

export default BookingApartmentStep


